<template>
    <TreatmentCategoryDetails/>
</template>
<script>
import TreatmentCategoryDetails from '../../components/treatment-categories/TreatmentCategoryDetails';

export default {
  components: {
    TreatmentCategoryDetails,
  },
};
</script>
